import { jsx as i, jsxs as h } from "react/jsx-runtime";
import * as l from "@radix-ui/react-avatar";
import { User as b } from "iconoir-react";
import * as o from "react";
import { cn as m } from "../../utils.js";
const d = o.forwardRef(({ className: a, ...r }, t) => /* @__PURE__ */ i(
  l.Root,
  {
    ref: t,
    className: m(
      "block size-10 shrink-0 overflow-hidden rounded-full border-2 border-white",
      a
    ),
    ...r
  }
));
d.displayName = "AvatarRoot";
const u = o.forwardRef(({ className: a, ...r }, t) => /* @__PURE__ */ i(
  l.Image,
  {
    ref: t,
    className: m("avatar-image", "size-full object-cover", a),
    ...r
  }
));
u.displayName = l.Image.displayName;
const p = o.forwardRef(({ className: a, name: r, ...t }, f) => {
  const c = ((s) => {
    if (!s) return "";
    const e = s.match(/\b(\w)/g);
    return e ? e.length === 1 ? e[0].toUpperCase() : [e[0], e[e.length - 1]].join("").toUpperCase() : "";
  })(r);
  return /* @__PURE__ */ i(
    l.Fallback,
    {
      ref: f,
      className: m(
        "avatar-fallback",
        "flex size-full items-center justify-center bg-decorative-one-100 font-medium text-decorative-one-200",
        a
      ),
      ...t,
      children: c || /* @__PURE__ */ i(b, {})
    }
  );
});
p.displayName = l.Fallback.displayName;
const g = ({ name: a, src: r, className: t, imgProps: f }) => {
  const n = o.useRef(null), [c, s] = o.useState("auto");
  return o.useEffect(() => {
    if (!n.current) return;
    const e = n.current.clientWidth;
    if (e < 1) {
      s("16px");
      return;
    }
    const v = `${e / 3}px`;
    s(v);
  }, [n, t]), /* @__PURE__ */ h(d, { className: t, ref: n, children: [
    /* @__PURE__ */ i(u, { ...f, className: "bg-white", src: r ?? void 0 }),
    /* @__PURE__ */ i(p, { name: a ?? void 0, style: { fontSize: c } })
  ] });
};
g.displayName = "Avatar";
export {
  g as Avatar,
  p as AvatarFallback,
  u as AvatarImage,
  d as AvatarRoot
};
